export const initialStore = {
  calculatorData: {
    portOperation: [],
    fleetList: [],
    clientQuery: {},
  },
  selectedVessels: {},
  syncBunker: false,
  isOverride: false,
  estimationEstId: "",
  splitHireArray: [{ hireRate: "", NoDays: "" }],
  portDistanceResponse: {},
  realPortDistanceResponse: {},
  portDistancePayloadResponse: {},
};
